import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  QueryList,
  SimpleChanges,
  ViewChildren,
} from '@angular/core';
import { VisitorPlaceService } from 'src/app/modules/event-calendar/services/visitor.place.service';
import { GooglePlaceReview } from 'src/app/modules/shared/models/visitor.place';

@Component({
  selector: 'ig-google-place-reviews',
  templateUrl: './google.place.reviews.component.html',
  styleUrls: ['./google.place.reviews.component.scss'],
})
export class GooglePlaceReviewsComponent implements AfterViewInit, OnChanges {
  readMoreCtrls: {
    need: boolean;
    show: boolean;
    height: 0;
  }[] = [];
  loading = false;
  defaultAvatar =
    'https://iti-images.s3.amazonaws.com/events/46a894bb-0ef0-270c-7118-e3bacdad1c9a.webp';

  @Input() reviews: GooglePlaceReview[];
  @Input() googleId: string = '';
  @ViewChildren('content') content: QueryList<ElementRef>;

  constructor(private _placeService: VisitorPlaceService) {}
  ngOnChanges(changes: SimpleChanges): void {
    this.filterReviews();
  }

  ngAfterViewInit(): void {
    this.processReviews();
  }

  show(i: number) {
    this.readMoreCtrls[i].show = !this.readMoreCtrls[i].show;
    this.content.toArray()[i].nativeElement.style.height = this.readMoreCtrls[i]
      .show
      ? this.readMoreCtrls[i].height + 'px'
      : '120px';
  }

  public sortReview(
    sort: 'recency' | 'relevancy' | 'highest_rating' | 'lowest_rating'
  ) {
    this.loading = true;
    this._placeService
      .getGooglePlaceReviews(this.googleId, sort)
      .subscribe((reviews) => {
        this.readMoreCtrls = [];
        this.filterReviews(reviews);
        this.processReviews();
        this.loading = false;
      });
  }

  getTime(review) {
    return (
      review.relative_time_description ||
      new Date(review.dateTimeISOString).toLocaleString()
    );
  }

  toArray(count: number) {
    return Array.from(Array(count).keys());
  }

  private filterReviews(reviews: GooglePlaceReview[] = this.reviews) {
    // show only reviews with rating >= 3. +x.rating means convert to number
    this.reviews = reviews.filter((x) => x.text && +x.rating >= 3);

    this.setMaxRating();
  }

  private setMaxRating() {
    // set max review.rating to 5, some weird comments may have it over 5
    this.reviews.forEach((review) => {
      if (+review.rating > 5) {
        review.rating = 5;
      }
    });
  }

  private processReviews() {
    setTimeout(() => {
      this.content.toArray().forEach((item, i) => {
        const element = item.nativeElement;
        if (
          element.offsetHeight < element.scrollHeight ||
          element.offsetWidth < element.scrollWidth
        ) {
          // show read more / read less button
          this.readMoreCtrls.push({
            need: true,
            show: false,
            height: element.scrollHeight,
          });
        } else {
          this.readMoreCtrls.push({
            need: false,
            show: false,
            height: element.scrollHeight,
          });
        }
      });
    });
  }
}
